/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sl_In_Reason_From_PurchaseInputs */

const vi_sl_in_reason_from_purchase = /** @type {(inputs: Sl_In_Reason_From_PurchaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Từ đơn mua`)
};

/**

* @param {Sl_In_Reason_From_PurchaseInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const sl_in_reason_from_purchase = /** @type {((inputs?: Sl_In_Reason_From_PurchaseInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sl_In_Reason_From_PurchaseInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sl_in_reason_from_purchase(inputs)
});